export const createAction = `
    mutation createAction($input: CreateActionInput!) {
        createAction(input: $input) {
            id
            actionCode
            name
            applicationId
            status
            createdByUsername
            created
    }
}`;

export const updateAction = `
    mutation updateAction($input: UpdateActionInput!) {
        updateAction(input: $input) {
            id
            actionCode
            name
            applicationId
            status
            createdByUsername
            updatedByUsername
            created
            updated
    }
}`;

// deleteAction returns a bare `ID`, not an object — no sub-selection.
export const deleteAction = `
    mutation deleteAction($input: DeleteActionInput!) {
        deleteAction(input: $input)
}`;

// setActionStatus takes DIRECT ARGS, not an input object. Status changes go
// through this mutation and never through updateAction — it is a conditional
// write, so an illegal transition fails loud and the error is surfaced.
export const setActionStatus = `
    mutation setActionStatus($id: ID!, $targetStatus: ActionStatus!) {
        setActionStatus(id: $id, targetStatus: $targetStatus) {
            id
            actionCode
            name
            applicationId
            status
            createdByUsername
            updatedByUsername
            created
            updated
    }
}`;
